import instance from "./axios";
import {
  FoilPeelTestEntry,
  AdhesionTest,
  FoilPeelTestPayload,
  FoilPeelTestFull,
} from "../types/foilPeelTestTypes";

export async function fetchFoilPeelTests(): Promise<FoilPeelTestEntry[]> {
  const response = await instance.get<FoilPeelTestEntry[]>(
    "/v1.0/Material/GetLastFoilPeel?num=3"
  );
  return response.data;
}

export async function fetchAdhesionTests(
  foilPeelIds: number[]
): Promise<AdhesionTest[]> {
  const params = new URLSearchParams();
  foilPeelIds.forEach((id) => params.append("foilPeelIds", id.toString()));
  const response = await instance.get<AdhesionTest[]>(
    `/v1.0/Material/GetLastAdhesionTestByFoilPeelIds?${params.toString()}`
  );
  return response.data;
}

export async function postFoilPeelTest(payload: FoilPeelTestPayload) {
  const response = await instance.post("/v1.0/Material/AddFoilPeel", payload);
  return response.data;
}

export async function fetchFoilPeelTestsEnriched(): Promise<
  FoilPeelTestFull[]
> {
  const peelTests = await fetchFoilPeelTests();
  const adhesionTests = await fetchAdhesionTests(peelTests.map((p) => p.id));

  const adhesionMap = new Map(adhesionTests.map((a) => [a.foilPeelTestId, a]));

  return peelTests.map((p) => {
    const adhesion = adhesionMap.get(p.id);
    return {
      ...p,
      adhesionEva: (adhesion?.adhesionEva as Record<string, number>) ?? {},
      adhesionBacksheet:
        (adhesion?.adhesionBacksheet as Record<string, number>) ?? {},
    };
  });
}
